import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-capacity-card',
  templateUrl: './capacity-card.component.html',
  styleUrls: ['./capacity-card.component.scss'],
  standalone: false
})
export class CapacityCardComponent {
  @Input() title: string;
  @Input() typeCapacite: 'maximale' | 'realiste';
  @Input() valeurPropriete: number;
  @Input() versementMensuel: number;
}
